/**
 * 合并两个列表并去重
 * @param tar 原列表
 * @param src 合并列表
 * @param key 去重字段
 * @returns 合并后的列表
 */
export const mergeList = (tar, src, key) => {
    const _cache = {};
    return src.concat(tar).reduce(function (item, next) {
        if (_cache[next[key]]) {
            _cache[next[key]] = true;
            item.push(next);
        }
        return item;
    }, []);
};
/**
 * 通过url下载文件
 * @param url
 * @param filename
 */
export const downloadByUrl = (url, filename) => {
    const anchor = document.createElement("a");
    if ("download" in anchor) {
        //html5 A[download]
        anchor.href = url;
        anchor.setAttribute("download", filename || "");
        anchor.innerHTML = "downloading...";
        anchor.style.display = "none";
        const _handler = function (e) {
            e.stopPropagation();
            this.removeEventListener("click", _handler);
        };
        anchor.addEventListener("click", _handler);
        document.body.appendChild(anchor);
        setTimeout(() => {
            anchor.click();
            document.body.removeChild(anchor);
        }, 66);
        return true;
    }
    else {
        // TODO：对其他版本的浏览器进行支持
    }
};
export const decodeStr = (str) => {
    return str
        .replace(/%25/g, '%')
        .replace(/%23/g, '#')
        .replace(/%26/g, '&')
        .replace(/%20/g, ' ');
};
